import { Link, useLocation } from "react-router-dom";
import { LogIn, Sparkles } from "lucide-react";
import { Section } from "./Bits";

/**
 * Shown on Coach / Recipes / Identify when the user is not logged in.
 * Blocks the paid AI endpoints from anonymous usage.
 */
export default function LoginGate({ title, subtitle, icon }) {
  const location = useLocation();
  const next = encodeURIComponent(location.pathname + location.search);
  const Ico = icon || Sparkles;
  return (
    <Section>
      <div className="max-w-md mx-auto text-center py-16" data-testid="ai-login-gate">
        <div
          className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-5"
          style={{ backgroundColor: "var(--wp-olive)", color: "var(--wp-cream)" }}
        >
          <Ico className="w-8 h-8" />
        </div>
        <h1 className="font-display text-4xl mb-3" style={{ color: "var(--wp-olive)" }}>
          {title || "Kurz anmelden"}
        </h1>
        <p className="opacity-80 mb-6">
          {subtitle || "Diese KI-Funktion ist nur für angemeldete Nutzer verfügbar – so schützen wir die Community vor Missbrauch und halten die Antworten schnell."}
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Link to={`/login?next=${next}`} className="btn-primary" data-testid="ai-gate-login">
            <LogIn className="w-4 h-4" /> Anmelden
          </Link>
          <Link to={`/register?next=${next}`} className="btn-secondary" data-testid="ai-gate-register">
            Kostenlos registrieren
          </Link>
        </div>
        <p className="text-xs opacity-60 mt-6">Ein Konto ist gratis und dauert 30 Sekunden.</p>
      </div>
    </Section>
  );
}
